module.exports = __webpack_public_path__ + "img/Frosundavik_logo_vit.98e6282d.svg";